var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9162",
    "data-name": "Group 9162",
    transform: "translate(0 -0.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(0 0.042)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9161",
    "data-name": "Group 9161",
    transform: "translate(23.156 32.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9160",
    "data-name": "Group 9160",
    transform: "translate(-4.066 -1.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9159",
    "data-name": "Group 9159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19696",
    "data-name": "Path 19696",
    d: "M63.513,86H3.953A3.958,3.958,0,0,0,0,89.953v36.9A3.958,3.958,0,0,0,3.953,130.8h59.56a3.957,3.957,0,0,0,3.953-3.953v-36.9A3.957,3.957,0,0,0,63.513,86Zm1.318,40.849a1.319,1.319,0,0,1-1.318,1.318H3.953a1.319,1.319,0,0,1-1.318-1.318v-36.9a1.319,1.319,0,0,1,1.318-1.318h59.56a1.319,1.319,0,0,1,1.318,1.318Z",
    transform: "translate(0 -86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19698",
    "data-name": "Path 19698",
    d: "M80,181.269v1.86a1.318,1.318,0,0,0,1.318,1.318H94.341a1.318,1.318,0,0,0,1.318-1.318v-1.86a7.783,7.783,0,0,0-3.226-6.326,5.006,5.006,0,0,0,.436-2.045v-1.86a5.038,5.038,0,1,0-10.077,0v1.86a5.008,5.008,0,0,0,.435,2.045A7.781,7.781,0,0,0,80,181.269Zm5.426-10.232a2.4,2.4,0,1,1,4.806,0v1.86a2.4,2.4,0,0,1-4.806,0Zm-2.79,10.232a5.244,5.244,0,0,1,2.262-4.278,5.022,5.022,0,0,0,5.865,0,5.166,5.166,0,0,1,2.26,4.279v.543H82.636Z",
    transform: "translate(-69.459 -155.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19699",
    "data-name": "Path 19699",
    d: "M81.319,328.636H94.341a1.318,1.318,0,1,0,0-2.635H81.319a1.318,1.318,0,1,0,0,2.635Z",
    transform: "translate(-69.459 -294.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19700",
    "data-name": "Path 19700",
    d: "M247.318,168.635h21.874a1.318,1.318,0,0,0,0-2.635H247.318a1.318,1.318,0,0,0,0,2.635Z",
    transform: "translate(-213.585 -155.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19702",
    "data-name": "Path 19702",
    d: "M247.318,288.635h21.874a1.318,1.318,0,0,0,0-2.635H247.318a1.318,1.318,0,1,0,0,2.635Z",
    transform: "translate(-213.585 -264.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19703",
    "data-name": "Path 19703",
    d: "M341.255,326H330.318a1.318,1.318,0,1,0,0,2.636h10.937a1.318,1.318,0,0,0,0-2.636Z",
    transform: "translate(-285.648 -299.019)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/License.f3eb99bb464284fdd36ddf5fa5d74fb0.svg";
export { ForwardRef as ReactComponent };